export type NatalChart = {
  natalChartData: NatalChartData;
  signsInfo: SignsInfo;
};

export type CreateNatalChartPublicPayload = {
  dateOfBirth: string;
  timeOfBirth: string;
  cityLocation: string;
  cityCoordinates: number[];
};

export type CreateNatalChartPayload = CreateNatalChartPublicPayload & {
  email: string;
  name: string;
};

export type UserNatalChartPayload = {
  date_birth: string;
  place_birth: string;
  lat: number;
  lng: number;
};

export type NatalChartData = {
  astroData: Record<PlanetNames, number[]>;
  cusps: number[];
  planetsInHouse: Record<keyof typeof PlanetNames, number>;
};

export type SignsInfo = {
  sunSign: string;
  moonSign: string;
  ascendantSign: string;
  venusSign: string;
  seventhHouseSign: string;
  marsSign: string;
  fifthHouseSign: string;
  mercurySign: string;
  tenthHouseSign: string;
  secondHouseSign: string;
};

export enum PlanetNames {
  sun = 'Sun',
  moon = 'Moon',
  mercury = 'Mercury',
  venus = 'Venus',
  mars = 'Mars',
  jupiter = 'Jupiter',
  saturn = 'Saturn',
  uranus = 'Uranus',
  neptune = 'Neptune',
  pluto = 'Pluto',
  chiron = 'Chiron',
}

export enum ZodiacSignDegrees {
  aries = 0,
  taurus = 30,
  gemini = 60,
  cancer = 90,
  leo = 120,
  virgo = 150,
  libra = 180,
  scorpio = 210,
  sagittarius = 240,
  capricorn = 270,
  aquarius = 300,
  pisces = 330,
}
